<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="pre_surtit" epub:type="title"><span><img alt="" class="imagelarge_intext" id="pre1a" src="images/pre1.jpg"/></span></h1>
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2"><i>F<span class="small">OREWORD</span> by Trillia J. Newbell</i></a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev2">1</span> On the Outside Looking In</a></div>
<div class="SOM_chap"><a href="#/chap2"><span class="mev2">2</span> Our Suffering Savior</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">3</span> Fellowship of the Suffering</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">4</span> Pleading for Rescue</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">5</span> Help My Unbelief</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">6</span> Ambiguous Loss</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev2">7</span> Learning to Lament</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev2">8</span> Finding Rest</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev2">9</span> Waiting on Jesus</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev2">10</span> Fellowship with the Cloud of Witnesses</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="mev2">11</span> Fellowship with the Rock</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample"><i>C<span class="small">ONCLUSION</span></i>: Limping Forward</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample"><i>A<span class="small">CKNOWLEDGMENTS</span></i></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample"><i>A<span class="small">PPENDIX</span></i>: Offering Companionship to the Suffering</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample"><i>N<span class="small">OTES</span></i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample"><i>S<span class="small">UGGESTED</span> R<span class="small">EADING</span></i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample"><i>S<span class="small">CRIPTURE</span> I<span class="small">NDEX</span></i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample"><i>P<span class="small">RAISE FOR</span></i> C<span class="small">OMPANIONS IN</span> S<span class="small">UFFERING</span></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample"><i>A<span class="small">BOUT THE</span> A<span class="small">UTHORS</span></i></span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample"><i>M<span class="small">ORE</span> T<span class="small">ITLES FROM</span> I<span class="small">NTER</span>V<span class="small">ARSITY</span> P<span class="small">RESS</span></i></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?61841d7e